import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const probateAttorneyNotesApi = createApi({
  reducerPath: "probateAttorneyNotesApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProbateAttorneyNote"],
  endpoints: (build) => ({
    getAllAttorneyNotes: build.query({
      query: () => ({ url: "/probate/attorney-notes", method: "GET" }),
      providesTags: ["ProbateAttorneyNote"],
    }),
    upsertAttorneyNote: build.mutation({
      query: ({ attorneyKey, notes, tags }) => ({
        url: `/probate/attorney-notes/${encodeURIComponent(attorneyKey)}`,
        method: "PUT",
        body: { notes, tags },
      }),
      invalidatesTags: ["ProbateAttorneyNote"],
    }),
    deleteAttorneyNote: build.mutation({
      query: (attorneyKey) => ({
        url: `/probate/attorney-notes/${encodeURIComponent(attorneyKey)}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ProbateAttorneyNote"],
    }),
  }),
});

export const {
  useGetAllAttorneyNotesQuery,
  useUpsertAttorneyNoteMutation,
  useDeleteAttorneyNoteMutation,
} = probateAttorneyNotesApi;
